import { iconAndAltForIntegrationType } from '../helpers/integrationHelpers';
import { AppStoreBuildType, IntegrationType } from '../types';
import * as React from 'react';
import Text from 'antd/lib/typography/Text';
import { antGrey, runwayColors } from './styles/globalStyles';
import { displayAppStoreBuildType } from '../helpers';
import Link from 'antd/lib/typography/Link';
import { AppstoreFilled } from '@ant-design/icons';

const BUILD_COMPONENT_TEXT_COLOR = runwayColors.black;

interface AppBuildComponentProps {
    integrationId: IntegrationType;
    buildIdentifier: string;
    type?: AppStoreBuildType;
    strong?: boolean;
    imgSize?: number;
    isProcessed: boolean;
}

export const AppBuildComponent: React.FC<AppBuildComponentProps> = (props: AppBuildComponentProps) => {
    const [icon, alt] = iconAndAltForIntegrationType(props.integrationId);
    const buildType = props.type ? displayAppStoreBuildType(props.type) : null;
    return (
        <div style={{ display: 'flex', alignItems: 'center', minWidth: 0 }}>
            {icon ?
                <img src={icon} alt={alt} width={props.imgSize ?? 20} height={props.imgSize ?? 20} />
            :   <AppstoreFilled style={{ fontSize: (props.imgSize ?? 20) - 1, color: antGrey.grey6 }} />}
            <Text
                strong={props.strong}
                style={{ color: props.isProcessed ? BUILD_COMPONENT_TEXT_COLOR : antGrey.grey7, marginLeft: 8 }}
                ellipsis
            >
                #{props.buildIdentifier}
                {props.type && props.type !== AppStoreBuildType.IosBinary ? ` (${buildType})` : null}
                {!props.isProcessed ? ` (processing)` : null}
            </Text>
        </div>
    );
};

interface CIBuildComponentProps {
    integrationId: IntegrationType;
    buildIdentifier: string;
    buildUrl?: string;
    asLink?: boolean;
    extra?: React.ReactNode;
    imgSize?: number;
    strong?: boolean;
}

export const CIBuildComponent: React.FC<CIBuildComponentProps> = (props: CIBuildComponentProps) => {
    const [icon, alt] = iconAndAltForIntegrationType(props.integrationId);

    return (
        <div style={{ display: 'flex', alignItems: 'center', minWidth: 0 }}>
            {icon ?
                <img src={icon} alt={alt} width={props.imgSize ?? 20} height={props.imgSize ?? 20} />
            :   <AppstoreFilled style={{ fontSize: (props.imgSize ?? 20) - 1, color: antGrey.grey6 }} />}
            {props.asLink === true && !!props.buildUrl ?
                <Link href={props.buildUrl} target="_blank" style={{ marginLeft: 8 }} strong={props.strong} ellipsis>
                    #{props.buildIdentifier}
                </Link>
            :   <Text strong={props.strong} style={{ color: BUILD_COMPONENT_TEXT_COLOR, marginLeft: 8 }} ellipsis>
                    Build #{props.buildIdentifier}
                </Text>
            }
            {props.extra}
        </div>
    );
};
